module.exports = __webpack_public_path__ + "img/plan3_book07.ecebd4bb.png";